





































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import hospitalMixin from './hospitalMixin'
import moment from 'moment'
import SoFarPicker from '@/components/task/SoFarPicker.vue'

@Component({
	components: {
		SoFarPicker,
	},
})
export default class HospitalizedLine extends Mixins(hospitalMixin) {
	@Prop({})
	private index!: number

	@Prop({})
	private initialVal!: any

	@Prop({})
	private ltMax!: boolean

	@Prop({})
	private disabled!: false

	private get initialRange() {
		if (this.initialVal) {
			return [
				moment(this.initialVal.beginTime),
				moment(this.initialVal.endTime),
			]
		} else {
			return []
		}
	}

	@Watch('initialVal', { immediate: true })
	private onInitialVal() {
		if (!this.initialVal) {
			return
		}

		this.$nextTick(() => {
			this.form.setFieldsValue({
				code: {
					label: this.initialVal.clinicArea,
					value: `${this.initialVal.province}-${this.initialVal.city}-${this.initialVal.area}`,
				},
				hospital: { label: this.initialVal.hospital, value: '' },
				// startendTime: [
				// 	moment(this.initialVal.beginTime),
				// 	moment(this.initialVal.endTime),
				// ],
			})
		})
	}

	private multiAdd(index: number) {
		this.$emit('multiAdd', index)
	}

	private multiRemove(index: number) {
		this.$emit('multiRemove', index)
	}

	private onRangeChange(range: any) {
		this.$nextTick(() => {
			this.form.setFieldsValue({
				startendTime: range,
			})
		})
	}

	private getForm() {
		return new Promise((resolve, reject) => {
			this.form.validateFields((err: any, values: any) => {
				if (!err) {
					let res: any = {}
					const codes = (values.code && values.code.key.split('-')) || []
					res.province = codes[0]
					res.city = codes[1]
					res.area = codes[2]
					res.clinicArea = values.code && values.code.label
					res.hospital = values.hospital && values.hospital.label
					const locArr = values.hospital.key.split('-')
					res.longitude = locArr[0]
					res.latitude = locArr[1]

					const startendTime = values.startendTime || []
					res.beginTime =
						startendTime[0] && startendTime[0].format('YYYY-MM-DD')
					res.endTime = startendTime[1] && startendTime[1].format('YYYY-MM-DD')

					resolve(res)
				} else {
					reject(err)
				}
			})
		})
	}

	public created() {
		this.form.getFieldDecorator('startendTime', {
			preserve: true,
			rules: [{ required: true, message: '请选择住院时间' }],
		})
	}
}
